/* eslint-disable */
require('webpack-jquery-ui');
require('webpack-jquery-ui/css')

export class Map {

    static CANVAS = 'canvas';
    static CONTEXT_MENU = 'context-menu';
    static MAP_CONTAINER = 'map-container'; //This element must be a static element in the DOM in order to receive events correctly
    static MAP_IMAGE = 'img';
    static MENU_ACtION = 'menu-action';
    static MENU_ITEM = 'menu-item';
    static POLYGON = 'polygon';
    static SVG = 'svg';

    // PHOENIX MODIFICATION BEGIN
    constructor(container, permissionToEdit, onPolygonChangeFunc) {
    // PHOENIX MODIFICATION END
        var self = this;
        var elements = this.elements = {};
        var canvas = {};
        var points = [];
        var isDrawing = false;
        var polygon;

        if (container === null) throw 'ArgumentNull Exception: container';
        if (container.tagName.toLowerCase() !== Map.MAP_CONTAINER) throw `Invalid Argument Exception : container must be of type "${Map.MAP_CONTAINER}"`;
        elements[Map.MAP_CONTAINER] = container;

        //Initialization methods
        (function appendElements() {
            let canvas = document.createElement(Map.CANVAS);  
            let image = document.createElement(Map.MAP_IMAGE);
            let svg = document.createElementNS('http://www.w3.org/2000/svg', Map.SVG);
            elements = {
                canvas: canvas,
                container: container,
                image: image,
                svg: svg
            };
            canvas.setAttribute('hidden', '');
            container.appendChild(image);
            container.appendChild(svg);
            container.appendChild(canvas);            
        })();
        (function initCanvas(width, height) {
            canvas.node = elements.canvas;
            canvas.context = canvas.node.getContext('2d');
            canvas.context.lineWidth = 1.5;
            canvas.context.strokeStyle = 'red';
            canvas.node.width = width;
            canvas.node.height = height;
        })(container.offsetWidth, container.offsetHeight);
        (function initContextMenus() {
            function createContextMenu(forElement, isHidden, action, text) {
                let contextMenu = document.createElement(Map.CONTEXT_MENU);
                contextMenu.setAttribute('for', forElement);
                isHidden ? contextMenu.setAttribute('hidden', '') : contextMenu.removeAttribute('hidden');

                let menuItem = document.createElement(Map.MENU_ITEM);
                menuItem.setAttribute(Map.MENU_ACtION, action);
                menuItem.innerText = text;
                contextMenu.appendChild(menuItem);
                return contextMenu;
            }
            let removePointMenu = createContextMenu('handlebar', true, 'remove-point', 'Remove Point');
            let addPointMenu = createContextMenu('canvas', true, 'add-point', 'Add Point');

            if (permissionToEdit) {
                elements.container.appendChild(removePointMenu);
                elements.container.appendChild(addPointMenu);
            }
        })();
        (function initEventListeners() {
            elements.svg.addEventListener('click', onSVGClick);
            container.addEventListener('click', onContainerClick);
            container.addEventListener('contextmenu', onContextMenu);            
        })();

        //Event handlers
        function onContainerClick(event) {
            switch (event.target.tagName.toLowerCase()) {
                case Map.MAP_CONTAINER:
                    break;
                case Map.MAP_IMAGE:
                    break;
                case Map.SVG:
                    break;
                case Map.CANVAS:
                    onCanvasClick(event);
                    break;
            }
        }
        function onCanvasClick(event) {
            if (!isDrawing) {
                isDrawing = true;
                points = [];
                document.body.addEventListener('mousemove', onMouseMove);
            }
            let rect = elements.canvas.getBoundingClientRect();
            let x = event.clientX - rect.left;
            let y = event.clientY - rect.top;
            let point = { x: x, y: y };
            points.push(point);
            drawPolyLine(points);
        }
        function onMouseMove(event) {
            let rect = elements.canvas.getBoundingClientRect();
            let x = event.clientX - rect.left;
            let y = event.clientY - rect.top;
            let point = { x: x, y: y };
            let clonedPoints = points.slice(0);
            clonedPoints.push(point);
            drawPolyLine(clonedPoints);
        }
        function clearContextMenus(event) {
            let menu = $('context-menu[for="canvas"]');
            menu.attr('hidden', '');
            menu.off();

            menu = $('context-menu[for="handlebar"]');
            menu.attr('hidden', '');
            menu.off();
        }
        function onContextMenu(event) {
            switch (event.target.tagName.toLowerCase()) {
                case Map.CANVAS:
                case Map.POLYGON:
                case Map.SVG:
                    onSVGContextMenu(event);
                    break;                
                default:
                    break;
            }
            event.preventDefault();
            event.stopPropagation();
            return false;
        } 
        function handleSVGContextMenuClick(event) {
            let target = event.target;
            target.parentElement.setAttribute('hidden', '');
            if (target.tagName.toLowerCase() === 'menu-item') {
                let action = target.getAttribute('menu-action');
                switch (action) {
                    case 'add-point':
                        let point = { x: (event.pageX - 170), y: (event.pageY - 600) };
                        addPoint(point);
                        break;
                }
                event.preventDefault();
                event.stopPropagation();
            }
        }
        function onSVGContextMenu(event) {
            clearContextMenus();

            let menu = document.querySelector('context-menu[for="canvas"]');

            menu.style.left =  (event.pageX - 170) + 'px';
            menu.style.top = (event.pageY - 600) + 'px';
            
            menu.removeAttribute('hidden');
            menu.addEventListener('click', handleSVGContextMenuClick, { once: true });

            event.preventDefault();
        }
        function onSVGClick(event) {
            let target = event.target;
            switch (target.tagName.toLowerCase()) {
                case Map.POLYGON:
                    polygon = target;
                    // PHOENIX MODIFICATION BEGIN
                    onPolygonChangeFunc(polygon);
                    // PHOENIX MODIFICATION END
                    hideAllPolygonHandles();
                    showPolygonHandles(target);
                    return false;
            }
        }

        //Drawing functions
        function clearCanvas() {
            canvas.context.clearRect(0, 0, canvas.node.width, canvas.node.height);            
        }
        function drawPolyLine(points) {
            clearCanvas();
            let ctx = canvas.context;
            ctx.strokeStyle = "#FF0000";
            ctx.beginPath();
            points.forEach(point => {
                ctx.lineTo(point.x, point.y);
            });
            ctx.stroke();
        } 
        function drawPolygon(event) {
            clearCanvas();
            hideAllPolygonHandles();
            polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
            let id = 'polygon_' + new Date().getTime();
            polygon.setAttribute('id', id);
            polygon.setAttribute('style', `fill: rgb(0,153,51,0.5);`);
            // PHOENIX MODIFICATION BEGIN
            onPolygonChangeFunc(polygon);
            // PHOENIX MODIFICATION END
            elements.svg.appendChild(polygon);
            //Normalize the points by removing the last two items (these get added inadvertently via double-clck )
            points.splice(points.length - 2, 2);
            points.forEach(point => {
                var svgPoint = elements.svg.createSVGPoint();
                svgPoint.x = point.x;
                svgPoint.y = point.y;
                polygon.points.appendItem(svgPoint);
            });
            points = [];
            document.body.removeEventListener('mousemove', onMouseMove);
            isDrawing = false;
            document.querySelector('canvas').setAttribute('hidden', '');
            polygon.handlebars = createHandlebars(polygon, id);
        }
        function addPoint(point) {
            var points = polygon.points;
            var lines = [];
            //Create an array of line segments
            for (let i = 0; i < points.numberOfItems; i++) {
                let index1 = i;
                let index2 = i + 1;
                if (index2 === points.numberOfItems) index2 = 0;
                let p1 = points.getItem(index1);
                let p2 = points.getItem(index2);
                lines.push([p1, p2]);
            }
            //Determine which line the point is closest to
            let nearestLine = null;
            let nearestDistance = 0;
            let insertBeforeIndex = 0;
            for (let i = 0; i < lines.length; i++) {
                let line = lines[i];
                let p1 = line[0];
                let p2 = line[1];
                let distance = getDistance(p1.x, p1.y, p2.x, p2.y, point.x, point.y);
                //Initialize value
                if (nearestDistance === 0) {
                    nearestDistance = distance;
                    nearestLine = line;
                    insertBeforeIndex = i + 1;
                }
                if (distance < nearestDistance) {
                    nearestDistance = distance;
                    nearestLine = line;
                    insertBeforeIndex = i + 1;
                }
            }
            //Add a point on the nearest line
            let x1 = nearestLine[0].x;
            let y1 = nearestLine[0].y;
            let x2 = nearestLine[1].x;
            let y2 = nearestLine[1].y;
            let nearestPoint = getNearestPointOnLine(x1, y1, x2, y2, point.x, point.y);
            var svgPoint = elements.svg.createSVGPoint();
            svgPoint.x = nearestPoint.x;
            svgPoint.y = nearestPoint.y;

            polygon.points.insertItemBefore(svgPoint, insertBeforeIndex);
            polygon.handlebars = createHandlebars(polygon, polygon.getAttribute('id'));
        }

        //https://stackoverflow.com/questions/8945134/resizing-and-dragging-svg-polygons-dynamically
        function createHandlebars(polygon, id) {
            var points = polygon.points;
            var handlebars = [];

            destroyHandlebars(polygon);

            for (var i = 0; i < points.numberOfItems; i++) {
                (function (i) { // close over variables for drag call back
                    var point = points.getItem(i);

                    var handle = document.createElement('div');
                    handle.setAttribute('polygon-id', id);
                    handle.className = 'handlebar';
                    handle.point = point;
                    container.appendChild(handle);
                    if (permissionToEdit) {
                        handle.addEventListener('contextmenu', function (event) {
                            clearContextMenus();

                            let menu = document.querySelector('context-menu[for="handlebar"]');

                            menu.style.left = (event.pageX - 170) + 'px';
                            menu.style.top = (event.pageY - 600) + 'px';

                            menu.removeAttribute('hidden');
                            menu.addEventListener('click', function (event) {
                                let target = event.target;

                                target.parentElement.setAttribute('hidden', '');
                                if (target.tagName.toLowerCase() === 'menu-item') {
                                    let action = target.getAttribute('menu-action');
                                    switch (action) {
                                        case 'remove-point':
                                            let index = 0;
                                            for (let i = points.numberOfItems - 1; i >= 0; i--) {
                                                let p = points.getItem(i);
                                                if (p.x === handle.point.x && p.y === handle.point.y) index = i;
                                            }
                                            points.removeItem(index);
                                            polygon.handlebars.splice(i, 1);
                                            handle.parentElement.removeChild(handle);
                                            break;
                                    }
                                }
                                event.preventDefault();
                                event.stopPropagation();
                                return false;
                            }, { once: true });
                            event.preventDefault();
                            event.stopPropagation();
                            return false;
                        });
                    }
                    handle.style.left = point.x + 'px';
                    handle.style.top = point.y + 'px';

                    if (permissionToEdit) {
                        $(handle).draggable({
                            drag: function (event) {
                                setTimeout(function () { // jQuery apparently calls this *before* setting position, so defer
                                    point.x = parseInt(handle.style.left);
                                    point.y = parseInt(handle.style.top);
                                }, 0);
                            }
                        });
                    }
                    handlebars.push(handle);
                } (i));
            }
            return handlebars;
        }
        function destroyHandlebars(polygon) {
            if (!polygon.handlebars) return;
            $('div[polygon-id="' + polygon.id + '"][class^="handlebar"]').remove()
            polygon.handlebars = [];
        }
        function showPolygonHandles(polygon) {
            if (polygon === null) return;

            clearContextMenus();

            // Show polygon handles
            let id = polygon.getAttribute('id');
            let handlebars = document.querySelectorAll('div[polygon-id="' + id + '"]');
            handlebars.forEach(handlebar => {
                handlebar.removeAttribute('hidden');
            });
        }
        function hidePolygonHandles(polygon) {            
            let id = polygon.getAttribute('id');
            let handlebars = document.querySelectorAll('div[polygon-id="' + id + '"]');
            handlebars.forEach(handlebar => {
                handlebar.setAttribute('hidden', '');
            });
        }
        function hideAllPolygonHandles() {
            let handlebars = document.querySelectorAll('div[polygon-id]');
            handlebars.forEach(handlebar => {
                handlebar.setAttribute('hidden', '');
            });
        }
        function togglePolygonHandles() {
            if (polygon === null) return;
            let id = polygon.getAttribute('id');
            let handlebars = document.querySelectorAll('div[polygon-id="' + id + '"]');
            handlebars.forEach(handlebar => {
                let isHidden = handlebar.hasAttribute('hidden');
                isHidden ? handlebar.removeAttribute('hidden') : handlebar.setAttribute('hidden', '');
            });
        }

        //Utility functions
        function getDistance(x1, y1, x2, y2, x3, y3) {
            let qx = x2 - x1;
            let qy = y2 - y1;
            let norm = qx * qx + qy * qy;
            let u = ((x3 - x1) * qx + (y3 - y1) * qy) / norm;
            if (u > 1) {
                u = 1;
            } else if (u < 0) {
                u = 0;
            }

            let x4 = x1 + u * qx;
            let y4 = y1 + u * qy;

            //Calculate distance
            let dx = x4 - x3;
            let dy = y4 - y3;
            let dist = (dx * dx + dy * dy) ** .5;
            return dist;

        }
        function getNearestPointOnLine(x1, y1, x2, y2, x3, y3) {
            let qx = x2 - x1;
            let qy = y2 - y1;
            let norm = qx * qx + qy * qy;
            let u = ((x3 - x1) * qx + (y3 - y1) * qy) / norm;
            if (u > 1) {
                u = 1;
            } else if (u < 0) {
                u = 0;
            }

            let x4 = x1 + u * qx;
            let y4 = y1 + u * qy;

            return { x: x4, y: y4 };

            //Calculate distance
            //let dx = x - x3;
            //let dy = y - y3;
            //let dist = (dx * dx + dy * dy) ** .5
            //return dist

        }
        function getNumberOfPolygons() {
            let polygons = document.querySelectorAll('polygon');
            return polygons ? polygons.length : 0;
        }

        function toggleAlarm() {
            if (polygon === null) return;
            let isAlarmed = polygon.getAttribute('class') === 'alarm';
            isAlarmed ? polygon.removeAttribute('class') : polygon.setAttribute('class', 'alarm');
        }
        // PHOENIX MODIFICATION BEGIN
        function hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            } : null;
        }
        // PHOENIX MODIFICATION END

        //Public functions
        this.load = function (url) {
            if (url === null || url.length === 0) throw 'ArgumentNull Exception: url';
            var buffer = elements.image.buffer = new Image();
            buffer.onload = function (event) {
                elements.image.src = buffer.src;
            };
            buffer.src = url;
        };
        this.getDrawMode = function () {
            return !canvas.hasAttribute('hidden');
        }
        this.setDrawMode = function (isEnabled) {
            console.log(`Draw Mode ${isEnabled ? 'enabled' : 'disabled'}`);

            let canvas = elements.canvas;
            let self = this

            let toggleDrawMode = document.querySelector('toolbar-button[toggle-draw-mode]')
            isEnabled ? toggleDrawMode.setAttribute('toggle-state-on', '') : toggleDrawMode.removeAttribute('toggle-state-on') 

            if (isEnabled) {
                if (canvas.hasAttribute('hidden')) {                 
                    canvas.removeAttribute('hidden');
                    hideAllPolygonHandles();
                    document.body.addEventListener('dblclick', function () {
                        drawPolygon();
                        self.setDrawMode(false);
                    }, { once: true });
                    points = [];
                }
            } else {
                if (!canvas.hasAttribute('hidden')) {
                    canvas.setAttribute('hidden', '');
                    document.body.removeEventListener('dblclick', drawPolygon, { once: true });
                }
            }
        };
        this.toggleHandles = togglePolygonHandles;
        this.toggleAlarm = toggleAlarm;
        // PHOENIX MODIFICATION BEGIN
        this.toggleAlarmForPolygon = function(toSet) {
            if (toSet === null) return;
            let isAlarmed = toSet.getAttribute('class') === 'alarm';
            isAlarmed ? toSet.removeAttribute('class') : toSet.setAttribute('class', 'alarm');
        };
        this.activateAlarmForPolygon = function(toSet) {
            if (toSet === null) return;
            toSet.setAttribute('class', 'alarm');
        };
        this.deactivateAlarmForPolygon = function(toSet) {
            if (toSet === null) return;
            toSet.removeAttribute('class');
        };
        this.setSelectedPolygon = function(toSet) {
            polygon = toSet;
        };
        this.drawPolygon = function(id, color, points, registered) {
            polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
            polygon.setAttribute('id', id)
            var rgb = hexToRgb(color)
            if (registered) {
                polygon.setAttribute('style', `fill: rgb(${rgb.r},${rgb.g},${rgb.b},0.5);`);
            } else {
                polygon.setAttribute('style', `fill: rgb(${rgb.r},${rgb.g},${rgb.b},0.5); stroke: red; stroke-width: 4;`);
                polygon.setAttribute('stroke-dasharray', '5,5');
            }
            elements.svg.appendChild(polygon);
            polygon.setAttribute('points', points)
            polygon.handlebars = createHandlebars(polygon, id);
            togglePolygonHandles();
        };
        // PHOENIX MODIFICATION END
    }
}